import { register } from '../component.js';
import 'react';

var _socialIcons_mailto = register("mailto", {"color":"#7f7f7f","path":"M41.1 25H22.9l9.1 7.1zm2.9 1.6-12 9.3-12-9.3V39h24zM0 0v64h64V0zm47 42H17V22h30z"});

export { _socialIcons_mailto as default };
